import { PagePayload } from '@core/interface/core';
import {
  AddHolidayTypeResponse,
  HolidayType,
  HolidayTypeError,
  HolidayTypeResponse,
} from '@core/interface/holiday-type';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const HolidayTypeActions = createActionGroup({
  source: 'HolidayType',
  events: {
    'Load Holiday Type': props<PagePayload>(),
    'Load Holiday Type Success': props<HolidayTypeResponse>(),
    'Load Holiday Type Failure': props<HolidayTypeError>(),
    'Add Edit Holiday Type': props<HolidayType>(),
    'Add Holiday Type Success': props<AddHolidayTypeResponse>(),
    'Update Holiday Type Success': props<AddHolidayTypeResponse>(),
    'Add Holiday Type Failure': props<HolidayTypeError>(),
    'Update Holiday Type Failure': props<HolidayTypeError>(),
  },
});
